"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IllegalReentrancyError = exports.OnlyCallableBySelfError = void 0;

var revert_error_1 = require("../../revert_error"); // tslint:disable:max-classes-per-file


var OnlyCallableBySelfError = /*#__PURE__*/function (_revert_error_1$Rever) {
  _inherits(OnlyCallableBySelfError, _revert_error_1$Rever);

  var _super = _createSuper(OnlyCallableBySelfError);

  function OnlyCallableBySelfError(sender) {
    _classCallCheck(this, OnlyCallableBySelfError);

    return _super.call(this, 'OnlyCallableBySelfError', 'OnlyCallableBySelfError(address sender)', {
      sender: sender
    });
  }

  return OnlyCallableBySelfError;
}(revert_error_1.RevertError);

exports.OnlyCallableBySelfError = OnlyCallableBySelfError;

var IllegalReentrancyError = /*#__PURE__*/function (_revert_error_1$Rever2) {
  _inherits(IllegalReentrancyError, _revert_error_1$Rever2);

  var _super2 = _createSuper(IllegalReentrancyError);

  function IllegalReentrancyError(selector, reentrancyFlags) {
    _classCallCheck(this, IllegalReentrancyError);

    return _super2.call(this, 'IllegalReentrancyError', 'IllegalReentrancyError(bytes4 selector, uint256 reentrancyFlags)', {
      selector: selector,
      reentrancyFlags: reentrancyFlags
    });
  }

  return IllegalReentrancyError;
}(revert_error_1.RevertError);

exports.IllegalReentrancyError = IllegalReentrancyError;
var types = [OnlyCallableBySelfError, IllegalReentrancyError]; // Register the types we've defined.

for (var _i = 0, _types = types; _i < _types.length; _i++) {
  var type = _types[_i];
  revert_error_1.RevertError.registerType(type);
}